module.exports = {
      id: "right-arrow-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite.svg#right-arrow",
      toString: function () {
        return this.url;
      }
    }